import { WalletWithdraw } from '@bz/wallet';

export const route = {
  info: {
    login: true,
  },
  preload() {
    WalletWithdraw.preload?.();
  },
} satisfies RouteDefinition;
export default WalletWithdraw;
